var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details-inner" }, [
    _c(
      "div",
      { staticClass: "sl-row sl-abs" },
      [
        _c(
          "div",
          { staticClass: "sl-col-12 no-padding" },
          [
            _c(
              "q-card",
              {},
              [
                _c(
                  "q-tabs",
                  {
                    staticClass: "col-12",
                    attrs: { "no-pane-border": "", align: "center" }
                  },
                  [
                    _c("q-tab", {
                      attrs: {
                        slot: "title",
                        default: "",
                        name: "details",
                        label: "Details",
                        alert:
                          _vm.validation.orderForm.$invalid ||
                          _vm.validation.$invalid
                      },
                      slot: "title"
                    }),
                    _c("q-tab", {
                      attrs: {
                        slot: "title",
                        name: "documents",
                        label: "Documents"
                      },
                      slot: "title"
                    }),
                    _c("q-tab-pane", {
                      staticClass: "fit",
                      attrs: { name: "details" }
                    }),
                    _c("q-tab-pane", {
                      staticClass: "no-padding",
                      attrs: { name: "documents" }
                    }),
                    _c("q-tab-pane", {
                      staticClass: "fit",
                      attrs: { name: "notes" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c("document-upload")
          ],
          1
        ),
        _c(
          "q-toolbar",
          [
            _vm.mode === "edit"
              ? _c("q-btn", {
                  attrs: { color: "red", label: "Remove" },
                  on: {
                    click: function($event) {
                      _vm.onRemove()
                    }
                  }
                })
              : _vm._e(),
            _c("q-toolbar-title"),
            _c(
              "div",
              { staticClass: "q-px-sm" },
              [
                _vm.mode === "edit"
                  ? _c("q-btn", {
                      staticClass: "q-px-md",
                      attrs: { label: "Upload", color: "green" },
                      on: {
                        click: function($event) {
                          _vm.openUploadModal()
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "q-px-sm" },
              [
                _vm.mode === "edit"
                  ? _c("q-btn", {
                      staticClass: "q-px-md",
                      attrs: {
                        color: "green",
                        label: "Save",
                        disable: _vm.$v.$invalid
                      },
                      on: {
                        click: function($event) {
                          _vm.onUpdate()
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "q-px-sm" },
              [
                _vm.mode === "add"
                  ? _c("q-btn", {
                      staticClass: "q-px-md",
                      attrs: {
                        color: "green",
                        label: "Add",
                        disable: _vm.$v.orderForm.$invalid
                      },
                      on: {
                        click: function($event) {
                          _vm.onAdd()
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c("q-btn", {
              attrs: { outline: "", color: "faded", label: "Cancel" },
              nativeOn: {
                click: function($event) {
                  return _vm.closeDetails($event)
                }
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }